import productInstance from '../instance'

const updateMenu = (menuId, data) => {
  return productInstance.put('/menus/' + menuId, data)
}

export default updateMenu
